import React, { Component } from "react";

import { api } from "../../../APIRequests";
import DashboardView from "../../../components/Provider/Dashboard/DashboardView";

class Home extends Component {
  state = {
    usersCount: null,
  };
  componentDidMount() {
    api.provider
      .fetch_patient_count()
      .then((cleanResponse) => {
        let usersCount = cleanResponse.user;

        this.setState({
          usersCount: usersCount,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  render() {
    return <DashboardView {...this.props} patient_count={this.state.usersCount} />;
  }
}

export default Home;
